import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { DialogModule } from "primeng/dialog";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { NavigationCancel, NavigationError, ResolveEnd, ResolveStart, Router } from "@angular/router";

@Component( {
  selector: 'app-blocking-loading-indicator',
  templateUrl: 'blocking-loading-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ DialogModule, ProgressSpinnerModule ]
} )
export class BlockingLoadingIndicatorComponent {
  protected visible$: WritableSignal<boolean> = signal(false);

  constructor(private readonly router: Router) {
    this.router.events.subscribe((event) => {
      if (event instanceof ResolveStart) {
        this.visible$.set(true);
      } else if (
        event instanceof ResolveEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.visible$.set(false);
      }
    });
  }
}
